<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" fxLayout="column" style="height: 100%"
  (click)="windowClick()">
  <dialog-header [label]="'MENUBAR.SIDE_VIEW' | translate: {trackTitle: trackTitle}" [dialogRef]='dialogRef'
    (mousedown)="windowClick()" [object]='this'></dialog-header>
  <div fxFlex class="chart-div">
    <canvas baseChart class="chart-canvas" chartType="line" legend="true" [colors]="chartColors"
      [options]="chartOptions" [datasets]="chartData">
    </canvas>
  </div>
  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="onFreeze()">{{frozen ? ('ACTIONS.RESUME' | translate) : ('ACTIONS.FREEZE' |
      translate)}}</button>
  </mat-dialog-actions>
</div>